module.exports = {
  'en-us': require('./locale/en-us.js'),
  'zh-cn': require('./locale/zh-cn.js'),
};
